module.exports = __webpack_public_path__ + "img/header-esportivo.8fa19eab.png";